import { render, staticRenderFns } from "./CommunityAddModal.vue?vue&type=template&id=e77803a0"
import script from "./CommunityAddModal.vue?vue&type=script&lang=js"
export * from "./CommunityAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports